<template>
  <span class="text-danger" v-show="errorBags.has(name)">
    <template v-if="isRequiredError"> {{ label }} is required. </template>
    <template v-else-if="isNumericError"> Please enter a valid number for {{ label.toLowerCase() }}. </template>
    <template v-else-if="isMaxValueError"> {{ label }} must not exceed Rp 999,999,999,999,999. </template>
    <template v-else>
      {{ errorBags.first(name) }}
    </template>
  </span>
</template>

<script>
export default {
  name: 'FormFieldError',
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    errorBags: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isRequiredError() {
      return this.errorBags.first(this.name) === `The ${this.name} field is required`
    },
    isNumericError() {
      return this.errorBags.first(this.name) === `The ${this.name} field may only contain numeric characters`
    },
    isMaxValueError() {
      return this.errorBags.first(this.name) === `The ${this.name} field must be 999999999999999 or less`
    },
  },
}
</script>
